/**
 * The platform figures under the landing page's hero ("N businesses trust our
 * platform", …), served by `GET /api/PlatformStats`.
 *
 * Social proof only works once the numbers are worth quoting: a strip of zeros,
 * or of "3 businesses", argues against signing up. So the strip has two locks:
 *
 *  - `enabled` is the decision. While it is false the section is not mounted at
 *    all — nothing rendered, and no request made on every visit to the page.
 *  - `minimums` is the safety net for after it is switched on. The section only
 *    appears once *every* figure has reached its floor; one weak number hides
 *    all four, because a strip with a gap in it reads worse than no strip.
 *    Until the figures have loaded, or if the request fails, nothing is shown —
 *    never placeholder zeros.
 */
export const PLATFORM_STATS = {
  enabled: false,
  minimums: {
    organizationsCount: 50,
    servicesCount: 200,
    bookingsCount: 1000,
    resourcesCount: 100,
  },
};

/** Whether `stats` (the PlatformStats response) is strong enough to publish. */
export const platformStatsWorthShowing = (stats, minimums = PLATFORM_STATS.minimums) =>
  stats != null &&
  Object.entries(minimums).every(([key, floor]) => Number(stats[key]) >= floor);
